import { FormExtractorService } from '../../../../shared/services/form-extractor.service';
import { LogService } from '../../../../shared/services/log.service';
import { Validator } from '../../../../shared/services/validator';
import { CTRL_NAME_EXTRACTOR } from '../../ctrl.name.extractor';

export class CTRL_290 implements Validator {

    public static id = 'CTRL_290';
    private message = 'error.ctr_290';


    public LOG: LogService = new LogService(CTRL_290);
    public formExtractorService: FormExtractorService = new FormExtractorService();

    
    validate(form: any, map) {

        
        // vérifier si la règle est applicable sur mon formulaire
        const rgs: string[] = CTRL_NAME_EXTRACTOR.getCtrlNames(form, CTRL_290.id + '_');

        if (rgs.length > 0) {
            for (const rg of rgs) {
                const ctrl = form.controls[rg];
                const qualite = form.controls[map.get(ctrl.value.rgCtrls.qualite)];
                const critere = ctrl.value.rgCtrls.critere;

                
                const controls = this.formExtractorService.getMapControlsIdWithoutStepAndValue(form);
                const critereQualite_iters = this.formExtractorService.getIndexes(Array.from(controls.keys()), ['critereQualite', 'TypeJOUECritereF01'], '_SepSep_TypeJOUECritereF01_index_');
                if (qualite.value) {
                    let nbCritere = 0;
                    for (let i = 1; i <= critereQualite_iters.size; i++) {
                        const critereCtrl = form.controls[map.get(critere.replace('INDEX_290_1', i))];
                        
                        if (critereCtrl.value !== '') {
                            nbCritere++;
                        }
                    }
                    if (nbCritere > 0) {
                        form.controls[rg].value = { rgCtrls: ctrl.value.rgCtrls, ctrlValidation: false };
                    } else {
                        // placer le message d'erreur
                        form.controls[rg].value = { rgCtrls: ctrl.value.rgCtrls, ctrlValidation: true, validation_message: this.message };
                    }
                }
            }
        }
    }
}
